import {Box, Paper} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {reverse} from 'named-urls';
import React, {useEffect, useMemo, useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import Switched from '../../../../components/Switched';
import Switcher from '../../../../components/Switcher';
import routes from '../../../../routes';
import Customs from './Customs';
import Items from './Items';

const useStyles = makeStyles((theme) => ({
  container: {
    '&.MuiPaper-root': {
      overflow: 'hidden',
      marginTop: theme.spacing(1),
    }
  }
}));

const Tabs = ({list, onListUpdated}) => {
  const classes = useStyles();
  const match = useRouteMatch();
  const [tab, setTab] = useState('');

  const tabs = useMemo(() => [
    {
      title: 'Items',
      slug: '',
      path: reverse(list.archived ? routes.archive.salesOrder.packingList.detail : routes.salesOrders.packingList.detail, {
        id: list?.order?.id ?? 0,
        listID: list?.id ?? 0
      })
    },
    {
      title: 'Addresses',
      slug: 'addresses',
      path: reverse(list.archived ? routes.archive.salesOrder.packingList.tab : routes.salesOrders.packingList.tab, {
        id: list?.order?.id ?? 0,
        listID: list?.id ?? 0,
        tab: 'addresses'
      })
    },
  ], [list]);

  useEffect(() => {
    if (match.params?.tab && tabs.findIndex(t => t.slug) >= 0) {
      setTab(match.params?.tab);
    } else {
      setTab('');
    }
  }, [match, tabs]);

  return (
    <>
      <Switcher tabs={tabs}/>
      <Switched tab="" currentTab={tab}>
        <Paper className={classes.container}>
          <Items list={list} onListUpdated={onListUpdated}/>
        </Paper>
      </Switched>
      <Switched tab="addresses" currentTab={tab}>
        <Box marginTop={-1}>
          <Customs list={list} onListUpdated={onListUpdated}/>
        </Box>
      </Switched>
    </>
  );
};

export default Tabs;
